import axios, { AxiosRequestConfig } from 'axios';

import i18n from '../i18n';
import { env } from '../utils/env';
const LANGUAGE_STORAGE_KEY = 'smartdocs-language';

export const axiosInstance = axios.create({
    baseURL: '',
});

axiosInstance.interceptors.request.use((config) => {
    const currentLanguage = i18n.language || localStorage.getItem(LANGUAGE_STORAGE_KEY) || 'pt-BR';
    
    if (config.headers) {
        const headers = config.headers as Record<string, string>;
        if (!headers['Accept-Language'] && !headers['accept-language']) {
            headers['Accept-Language'] = currentLanguage;
        }
    }
    
    return config;
});

export const customInstance = <T>(
    url: string,
    options?: RequestInit,
): Promise<T> => {
    const source = axios.CancelToken.source();

    const config: AxiosRequestConfig = {
        url,
        method: options?.method as any,
        headers: options?.headers as any,
        data: options?.body,
        signal: (options?.signal ?? undefined) as any,
        responseType: (options as any)?.responseType,
    };

    const promise = axiosInstance({
        ...config,
        cancelToken: source.token,
    }).then(({ data }) => data);

    // @ts-ignore
    promise.cancel = () => {
        source.cancel('Query was cancelled');
    };

    return promise as unknown as Promise<T>;
};

export const customInstanceDocumentos = <T>(
    url: string,
    options?: RequestInit,
): Promise<T> => {
    return customInstance<T>(`/api/documentos${url}`, options);
};

export const getBpmPrefix = () => {
    const bpmUrl = env.VITE_APP_SMARTBPM_URL || '';
    let prefix = '/api/smartbpm';

    try {
        if (bpmUrl && bpmUrl.startsWith('http')) {
            const urlObj = new URL(bpmUrl);
            const pathname = urlObj.pathname.replace(/\/$/, '');
            if (pathname && pathname !== '/') {
                prefix = `${pathname}/smartbpm`;
            }
        }
    } catch {
        return prefix;
    }

    return prefix;
};

export const customInstanceBpm = <T>(
    url: string,
    options?: RequestInit,
): Promise<T> => {
    return customInstance<T>(`${getBpmPrefix()}${url}`, options);
};

export const customInstanceSmartForm = <T>(
    url: string,
    options?: RequestInit,
): Promise<T> => {
    return customInstance<T>(`/api/smartform${url}`, options);
};

export const customInstanceEmailProcess = <T>(
    url: string,
    options?: RequestInit,
): Promise<T> => {
    return customInstance<T>(`/api/email-process${url}`, options);
};

export const setAuthToken = (token?: string) => {
    if (token) {
        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
        delete axiosInstance.defaults.headers.common['Authorization'];
    }
};

export const setTenantHeader = (tenant: string) => {
    axiosInstance.defaults.headers.common['tenant'] = tenant;
}
